export default __webpack_public_path__ + "static/media/imgEnd.5ed1c143.svg";